export default __webpack_public_path__ + "images/0x85955046df4668e1dd369d2de9f3aeb98dd2a369.png";